import { z } from 'zod';

export const PromptLLMResponseSchema = z.object({
  response: z.string(),
});

export type IPromptLLMResponseDto = z.infer<typeof PromptLLMResponseSchema>;
